export default {
  cnae: state => state.cnae
};
